import { OuterContentItem, SubHeading } from "@certn/cascadia-react";
import { CascadiaControlProps } from "@certn/forms";
import {
  convertDataToDisplayValues,
  getItemList,
  splitAndCapitalize,
} from "@certn/forms/src/controls/utils";
import { composePaths } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { Fragment } from "react";

export function ArrayModalControlSummary(props: CascadiaControlProps) {
  const { path, data, schema, uischema } = props;
  return (
    <>
      {data?.map((item: Record<string, unknown>, i: number) => {
        const childPath = composePaths(path, `${i}`);

        const itemDisplayValues = convertDataToDisplayValues(
          item,
          props.schema
        );

        const title = getItemList(
          [uischema.options?.elementLabel ?? Object.keys(item)[0]],
          itemDisplayValues
        ).filter(Boolean)[0];

        const subtitles = getItemList(
          uischema.options?.elementSubLabels ?? Object.keys(item),
          itemDisplayValues
        )
          .filter(Boolean)
          .join(", ");

        return (
          <Fragment key={childPath}>
            <SubHeading children={props.label} />
            <OuterContentItem
              title={splitAndCapitalize(title)}
              subtitle={subtitles === "undefined" ? undefined : subtitles}
              key={i}
              testID={`${props.path}-summary-item-outer-content`}
            >
              <JsonFormsDispatch
                schema={schema}
                uischema={uischema}
                path={childPath}
                key={childPath}
              />
            </OuterContentItem>
          </Fragment>
        );
      })}
    </>
  );
}
